/**
 * The local mock-login bundle is the only runtime allowed to use browser-side fixtures.
 * Both checks are compile-time Vite constants, so production builds cannot enable this path
 * even if a similarly named value is present at runtime.
 */
export interface LocalDevMockEnvironment {
  readonly DEV: boolean;
  readonly VITE_DEV_MOCK_AUTH?: string;
}

export function isLocalDevMockAuth(
  environment: LocalDevMockEnvironment = import.meta.env,
): boolean {
  return environment.DEV && environment.VITE_DEV_MOCK_AUTH === "true";
}
